import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useCollection } from "react-firebase-hooks/firestore";
import {
  collection,
  doc,
  setDoc,
  orderBy,
  query,
} from "firebase/firestore";
import AgoraUIKit from "agora-react-uikit";
import { getAgoraToken, setCreatorOnline } from "../../service/api";
import db from "../../firebase.config";

const LivePage = () => {
  const [videoCall, setVideoCall] = useState(false);
  const [initalLoad, setInitalLoad] = useState(true);
  const [token, setToken] = useState(null);
  const [room, setRoom] = useState("");
  const [isRoomJoined , setRoomJoined] = useState(false);

  const navigate = useNavigate();

  const data = JSON.parse(sessionStorage.getItem("creatordata"));

  const getData = async() =>{
    const room = await setCreatorOnline(data.email, Date.now());

    const token = await getAgoraToken(data.email);
    setToken(token.token);
    setVideoCall(true);
    setRoom(room.room_id);
    setInitalLoad(false);
    setRoomJoined(true);
    await setDoc(doc(db, "chats", room.room_id), {});

  }

  useEffect(() => {
    getData();
  }, []);

  const rtcProps = {
    appId: "a6c12e924ed84f5ea68ee2994a502c9d",
    channel: data.email,
    token: token,
    role: "host",
  };

  const styleProps = {
    localBtnContainer: { backgroundColor: "blueviolet" },
  };

  const callbacks = {
    EndCall: () => setVideoCall(false),
  };

  return (
    <div className="flex w-screen">
      <div
        style={{
          width: "61%",
          height: "100vh",
          display: "flex",
          flex: 1,
          backgroundColor: "#007bff22",
        }}
      >
        {videoCall ? (
          <>
            <AgoraUIKit
              rtcProps={rtcProps}
              callbacks={callbacks}
              styleProps={styleProps}
            />
          </>
        ) : initalLoad ? (
          <>Loading ....</>
        ) : (
          <>
            <h3
              style={{
                backgroundColor: "#007bff",
                cursor: "pointer",
                height: "2rem",
                borderRadius: 5,
                padding: 5,
                color: "#ffffff",
                fontSize: 20,
                margin: "2px",
              }}
              onClick={() => navigate("/creator")}
            >
              Go Back
            </h3>
          </>
        )}
      </div>
      <div style={{ width: "38%", height: "95vh" }}>
        {isRoomJoined && <Chat room={room} />}
      </div>
    </div>
  );
};

export default LivePage;

function Chat({ room }) {

  const scroll = useRef();

    

  const [value, loading, error] = useCollection(
        query(collection(db, "chats", room, "messages"), orderBy("timestamp")),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );

  return (
    <div className="flex flex-col justify-end h-full">
      <div className="msgs">
      {value && (
          <span key={value.docs.length}>
            {value.docs.map((doc, index) => (
               <div className="flex items-start gap-2 p-1.5" key={index.toString()}>
               <img
                 src={`${doc.data().photoURL}`}
                 alt="user"
                 className="rounded-full w-8 h-8"
               />
               <div className="flex flex-col justify-start">
                 <p className="font-semibold">{doc.data().name}</p>
                 {doc.data().type === "text" ? (
                   <p className="text-xs">{doc.data().message}</p>
                 ) : (
                   <img
                     src={`${doc.data().image}`}
                     className="w-40 h-32 object-cover object-center rounded-md"
                     alt=""
                     key={doc.data().image}
                   />
                 )}
               </div>
             </div>
            ))}
          </span>
        )}
      </div>
      {/* <div ref={scroll}></div> */}
    </div>
  );
}
